export default "__VITE_ASSET__dca8b128__"